import React from 'react';
import './FilterBar.css';

function FilterBar({
                       currentMealStyles,
                       onMealStyleChange,
                       onClearMealFilters,
                       currentKosherOptions,
                       onKosherOptionChange,
                       onClearKosherFilters,
                       onMapToggle,
                       showMap,
                       isMobileOpen,         // חדש
                       onCloseMobile         // חדש
                   }) {
    const mealStyles = [
        { value: "vegan", label: "Vegan" },
        { value: "Vegetarian", label: "Vegetarian" },
        { value: "students", label: "Students" },
        { value: "traditional", label: "Traditional" },
        { value: "family", label: "Family Style" },
        { value: "large group", label: "Large Group" },
        { value: "intimate", label: "Intimate Dinner" },
    ];

    const kosherOptions = [
        { value: "Kosher (basic)", label: "Kosher (Basic)" },
        { value: "Kosher Mehadrin", label: "Kosher Mehadrin" },
        { value: "Non Kosher", label: "Non-Kosher" },
    ];

    // Detect mobile (SSR safe)
    const [isMobile, setIsMobile] = React.useState(
        typeof window !== "undefined" ? window.innerWidth <= 600 : false
    );
    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 600);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Mobile popup
    if (isMobile) {
        return isMobileOpen ? (
            <div className="filterbar-mobile-overlay" onClick={onCloseMobile}>
                <div className="filterbar-mobile-popup" onClick={e => e.stopPropagation()}>
                    <button
                        className="filterbar-close-btn"
                        onClick={onCloseMobile}
                        aria-label="Close filters"
                    >
                        &times;
                    </button>
                    <h2 className="filters-title"><i className="fas fa-filter"></i> Filters</h2>
                    <div className="filter-section">
                        <h3>
                            Kosher
                            {currentKosherOptions.size > 0 && (
                                <button className="clear-filter-button" onClick={onClearKosherFilters}>
                                    <i className="fas fa-broom" style={{marginRight: 4}}></i>Clear
                                </button>
                            )}
                        </h3>
                        {kosherOptions.map(option => (
                            <label key={option.value}>
                                <input
                                    type="radio"
                                    name="kosher"
                                    value={option.value}
                                    checked={currentKosherOptions.has(option.value)}
                                    onChange={() => onKosherOptionChange(option.value)}
                                /> {option.label}
                            </label>
                        ))}
                    </div>
                    <div className="filter-section">
                        <h3>
                            Meal Style
                            {currentMealStyles.size > 0 && (
                                <button className="clear-filter-button" onClick={onClearMealFilters}>
                                    <i className="fas fa-broom" style={{marginRight: 4}}></i>Clear
                                </button>
                            )}
                        </h3>
                        {mealStyles.map(style => (
                            <label key={style.value}>
                                <input
                                    type="checkbox"
                                    name="mealStyle"
                                    value={style.value}
                                    checked={currentMealStyles.has(style.value)}
                                    onChange={() => onMealStyleChange(style.value)}
                                /> {style.label}
                            </label>
                        ))}
                    </div>
                    <div className="map-section">
                        <button className="map-toggle-btn" onClick={onMapToggle}>
                            <span className="map-icon">🗺️</span>
                            <span className="map-toggle-btn-text">
                            {showMap ? 'Cards View' : 'Map View'}
                        </span>
                        </button>
                    </div>
                </div>
            </div>
        ) : null;
    }

    // Desktop sidebar
    return (
        <div className="filters-container">
            <h2 className="filters-title"><i className="fas fa-filter"></i> Filters</h2>
            <div className="filter-section">
                <h3>
                    Kosher
                    {currentKosherOptions.size > 0 && (
                        <button className="clear-filter-button" onClick={onClearKosherFilters}>
                            <i className="fas fa-broom" style={{marginRight: 4}}></i>Clear
                        </button>
                    )}
                </h3>
                {kosherOptions.map(option => (
                    <label key={option.value}>
                        <input
                            type="radio"
                            name="kosher"
                            value={option.value}
                            checked={currentKosherOptions.has(option.value)}
                            onChange={() => onKosherOptionChange(option.value)}
                        /> {option.label}
                    </label>
                ))}
            </div>
            <div className="filter-section">
                <h3>
                    Meal Style
                    {currentMealStyles.size > 0 && (
                        <button className="clear-filter-button" onClick={onClearMealFilters}>
                            <i className="fas fa-broom" style={{marginRight: 4}}></i>Clear
                        </button>
                    )}
                </h3>
                {mealStyles.map(style => (
                    <label key={style.value}>
                        <input
                            type="checkbox"
                            name="mealStyle"
                            value={style.value}
                            checked={currentMealStyles.has(style.value)}
                            onChange={() => onMealStyleChange(style.value)}
                        /> {style.label}
                    </label>
                ))}
            </div>
            <div className="map-section">
                <button className="map-toggle-btn" onClick={onMapToggle}>
                    <span className="map-icon">🗺️</span>
                    <span className="map-toggle-btn-text">
            {showMap ? 'Cards View' : 'Map View'}
          </span>
                </button>
            </div>
        </div>
    );
}

export default FilterBar;